<template>
    <div class="my-promotion" style="padding-top: 1rem">
        <!--<navTitle title="我的推广" path="/user"></navTitle>-->
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : $t('message.promoter.title')" path="/user"></navTitle>
        <div v-if="start">
            <!--提交代理申请-->
            <div class="frist" v-if="is_promoter==0 && (apply==''||apply.status==0||apply.status==2)">
                <p class="T1">{{$t('message.promoter.apply_agency')}}</p>
                <!--        <p class="N1">This is a simple application. Please submit a photo to prove your qualifications for the position!</p>-->
                <!--        <img v-if="!updata" class="hello" src="@assets/images/concept.png" alt="">-->
                <!--        <img v-else class="hello" @load="imageUploadEnd" :src="updata" alt="">-->
                <!--        <div class="pictrue" >-->
                <!--          <VueCoreImageUpload-->
                <!--                  class="btn btn-blue"-->
                <!--                  :crop="false"-->
                <!--                  compress="80"-->
                <!--                  @imageuploaded="imageuploaded"-->
                <!--                  :headers="headers"-->
                <!--                  :max-file-size="5242880"-->
                <!--                  :credentials="false"-->
                <!--                  inputAccept="image/*"-->
                <!--                  inputOfFile="file"-->
                <!--                  :url="url"-->
                <!--                  ref="upImg"-->
                <!--                  v-if="!updataYes"-->
                <!--                  @click="imageUploadStar"-->
                <!--          >-->
                <!--            Submit Photo-->
                <!--          </VueCoreImageUpload>-->
                <!--          <div class="btn-wrap" v-if="updataYes">-->
                <!--            <div class="btn" @click="cancleApply">Cancle</div>-->
                <!--            <div class="btn btn-blue" @click="ConfirmApply">Confirm</div>-->
                <!--          </div>-->
                <!--          <div class="tips">Upload may be delayed, please wait a while and do not click repeatedly！</div>-->

                <!--        </div>-->
                <div class="btn btn-blue" @click="ConfirmApply">{{$t('message.promoter.become_agent')}}</div>
                <div class="tips">{{$t('message.promoter.repeatedly_delayed')}}</div>
            </div>
            <!--代理审核中-->
            <!--      <div class="second"  v-if="is_promoter==0 && apply.status==0">-->
            <!--        <p class="T1">Apply for agency <br> and become one of us</p>-->
            <!--        <p class="N1">We are very glad that we have received your application, we are reviewing it, it will take some time, please wait</p>-->
            <!--        <img class="hello" @load="imageUploadEnd" :src="apply.img" alt="">-->
            <!--      </div>-->
            <!--代理审核拒绝-->
            <!--      <div class="second"  v-if="is_promoter==0 && apply.status==2">-->
            <!--        <p class="T1">Apply for agency <br> and become one of us</p>-->
            <!--        <p class="N1">Sorry, your application was rejected.</p>-->
            <!--        <p class="N1">{{apply.mark}}</p>-->
            <!--        <img class="hello" @load="imageUploadEnd" :src="apply.img" alt="">-->
            <!--        <div class="btn btn-blue" @click="ToSubmitAgain">To submit again</div>-->

            <!--      </div>-->

            <!--代理界面-->
            <div class="third" v-if="is_promoter==1">
                <div class="header">
                    <div class="name acea-row row-center-wrapper">
                        <div>{{$t('message.promoter.current_commission')}}</div>
                        <router-link class="record" :to="'/user/cashrecord'">
                            {{$t('message.promoter.record')}}<span class="iconfont icon-xiangyou"></span>
                        </router-link>
                    </div>
                    <div class="num">{{ parseInt(userInfo.extractPrice) | MoneyFormat}}</div>
                    <div class="profit acea-row row-between-wrapper">
                        <div class="item">
                            <div>{{$t('message.promoter.profit_yesterday')}}</div>
                            <div class="money">{{ userInfo.yesterDay || 0 }}</div>
                        </div>
                        <div class="item">
                            <div>{{$t('message.promoter.accumulated_withdrawal')}}</div>
                            <div class="money">{{ parseInt(userInfo.extractTotalPrice) | MoneyFormat}}</div>
                        </div>
                    </div>
                </div>
                <div class="bnt bg-color-red" @click="toCash">{{$t('message.promoter.withdraw')}}</div>
                <div class="list acea-row row-between-wrapper">
      <span class="item acea-row row-center-wrapper row-column copy-data" :data-clipboard-text="linkText"
            @click="copyLink">
        <span class="iconfont icon-fenxiang"></span>
        <div>{{$t('message.promoter.refer_friends')}}</div>
      </span>
                    <!--<router-link-->
                    <!--class="item acea-row row-center-wrapper row-column"-->
                    <!--:to="'/user/poster'"-->
                    <!--&gt;-->
                    <!--&lt;!&ndash;<span class="iconfont icon-erweima"></span>&ndash;&gt;-->
                    <!--<span class="iconfont icon-fenxiang"></span>-->
                    <!--<div>Refer Friends</div>-->
                    <!--</router-link>-->
                    <router-link
                            class="item acea-row row-center-wrapper row-column"
                            :to="'/user/promoter_list'"
                    >
                        <span class="iconfont icon-tongji"></span>
                        <div>{{$t('message.promoter.total_agent')}}</div>
                    </router-link>
                    <router-link
                            class="item acea-row row-center-wrapper row-column"
                            :to="'/user/commission'"
                    >
                        <span class="iconfont icon-qiandai"></span>
                        <div>{{$t('message.promoter.promoter_achievements')}}</div>
                    </router-link>
                    <router-link
                            class="item acea-row row-center-wrapper row-column"
                            :to="'/user/promoter_order'"
                    >
                        <span class="iconfont icon-dingdan"></span>
                        <div>{{$t('message.promoter.promoter_orders')}}</div>
                    </router-link>
                    <router-link
                            class="item acea-row row-center-wrapper row-column"
                            :to="'/user/promoter_rank'"
                    >
                        <span class="iconfont icon-paihang1"></span>
                        <div>{{$t('message.promoter.promoter_ranking')}}</div>
                    </router-link>
                    <router-link
                            class="item acea-row row-center-wrapper row-column"
                            :to="'/user/commission/rank'"
                    >
                        <span class="iconfont icon-paihang"></span>
                        <div>{{$t('message.promoter.commission_ranking')}}</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getUser, promoter_applyInfo,become_anent} from "../../../api/user";
    import navTitle from "@components/navTitle";
    import ClipboardJS from "clipboard";
    import {VUE_APP_API_URL} from "@utils";

    export default {
        name: "UserPromotion",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                start: false,
                userInfo: {},
                linkText: '',
                is_promoter: '',
                apply: "",
                url: `${VUE_APP_API_URL}/upload/image`,
                headers: {
                    "Authori-zation": "Bearer " + this.$store.state.app.token
                },
                updata: "",
                updataYes: false
            };
        },
        mounted: function () {
            this.getInfo();
            promoter_applyInfo().then(res => {
                console.log('promoter_applyInfo', res)
                this.apply = res.data.apply
                this.start = true
            })
                .catch(res => {
                    this.$dialog.error(res.msg)
                })
        },
        methods: {
            ToSubmitAgain() {
                this.updata = ""
                this.updataYes = false
                this.apply = ""
            },
            cancleApply() {
                this.updata = ""
                this.updataYes = false
            },
            ConfirmApply() {
                console.log('become_anent1', this.apply.uid)
                become_anent({uid: this.apply.uid}).then(res => {
                    console.log('become_anent2', res)
                    this.$dialog.loading.close()
                    this.$dialog.toast({mes: res.msg})
                    setTimeout(function () {
                        window.location.reload()
                    }, 3000)
                }).catch(res => {
                    console.log('become_anent2', res)
                    this.$dialog.loading.close()
                    this.$dialog.toast({mes: res.msg})
                })
            },
            imageUploadStar() {
                console.log('aaaaaaa')
                this.$dialog.loading.open('loading...')
            },
            imageUploadEnd() {
                this.$dialog.loading.close()
                this.updataYes = true
            },
            imageuploaded(res) {
                console.log('imageuploaded', res)
                if (res.status !== 200)
                    return this.$dialog.error(res.msg || "Upload picture failed");
                this.$dialog.loading.open('loading...')
                this.updata = res.data.url
            },

            copyLink: function () {
                let copybtn = document.getElementsByClassName("copy-data");
                const clipboard = new ClipboardJS(copybtn);
                clipboard.on("success", () => {
                    this.$dialog.success(this.$t('message.promoter.copy_success'));
                });
                clipboard.on("error", res => {
                    this.$dialog.success(this.$t('message.promoter.copy_error') + res);
                });
            },
            getInfo: function () {
                let that = this;
                getUser().then(
                    res => {
                        that.userInfo = res.data;
                        that.is_promoter = res.data.is_promoter
                        that.linkText = 'IM2018, một trang web tăng gấp đôi tiền mặt.\n' +
                            'Mở trang web của tôi trong trình duyệt, ít nhất ₫10000  mỗi ngày!\n' + res.data.shortlink
                        // console.log(that.userInfo);
                    },
                    function (err) {
                        that.$dialog.message(err.msg);
                    }
                );
            },
            toCash: function () {
                this.$router.push({path: "/user/user_cash"});
            }
        }
    };
</script>
<style scoped>
    .frist, .second {
        text-align: center;
        padding: 0 0.28rem;
    }

    .hello {
        width: 5rem;

    }

    .btn-wrap {
        display: flex;
        justify-content: space-between;
    }

    .btn {
        width: 3rem;
        height: 1rem;
        border-radius: 3px;
        line-height: 1rem;
        text-align: center;
        font-size: 0.35rem;
        margin: 1rem auto 0.6rem auto;
        border: 1px solid #666;
    }

    .btn-blue {
        color: #fff;
        background: #00c3f9;
        border: 1px solid #00c3f9;

    }

    .T1 {
        font-size: 0.5rem;
        font-weight: bold;
        margin: 0.4rem 0;
    }

    .N1 {
        font-size: 0.3rem;
        color: #333;
        margin: 0rem 0 0.8rem 0;

    }

    .tips {
        font-size: 0.25rem;
        color: #999;
    }

</style>
